/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum RecommendationSource {
    AWS_compute_optimizer = 'AWS-compute-optimizer',
    AWS_ec2_compute_optimizer = 'AWS-ec2-compute-optimizer',
    AWS_lambda_compute_optimizer = 'AWS-lambda-compute-optimizer',
    AWS_advisor = 'AWS_advisor',
    Corestack_Profiler = 'Corestack-Profiler',
    Custom = 'Custom',
    GCP_advisor = 'GCP_advisor',
    OCI_advisor = 'OCI_advisor',
    activity_log = 'activity_log',
    azure_advisor = 'azure_advisor',
    azure_microsoft_defender_for_cloud = 'azure_microsoft_defender_for_cloud',
    policy = 'policy',
    security_threats = 'security_threats'
}
